module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    class: {
      'mt-50 mb-50': _vm.showStar
    }
  }, [(_vm.showStar) ? _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "src": require("assets/img/star.png")
    }
  })]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "crowd-or-rais"
  }, [_c('router-link', {
    staticClass: "crowd-or uppercase",
    attrs: {
      "to": "/crowdfunding"
    }
  }, [_vm._v(_vm._s(_vm.$t("project.crowdfunding")))]), _vm._v(" "), _c('span', {
    staticClass: "or"
  }, [_vm._v(_vm._s(_vm.$t("whether")))]), _vm._v(" "), _c('router-link', {
    staticClass: "rais-or uppercase",
    attrs: {
      "to": "/fundraising"
    }
  }, [_vm._v(_vm._s(_vm.$t("project.fundraising")) + "?")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8625acb2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CrowdOrRais.vue
// module id = 826
// module chunks = 1